package org.multipaz.utopia.generated

/**
 * Generated strings for language: hi
 * DO NOT EDIT - This file is auto-generated by the generateMultipazStrings task
 */
internal val strings_hi = mapOf(
    "boarding_pass_attribute_departure_time" to "प्रस्थान समय",
    "boarding_pass_attribute_flight_number" to "उड़ान संख्या",
    "boarding_pass_attribute_passenger_name" to "यात्री का नाम",
    "boarding_pass_attribute_seat_number" to "सीट संख्या",
    "boarding_pass_description_departure_time" to "प्रस्थान की तिथि और समय",
    "boarding_pass_description_flight_number" to "उड़ान संख्या",
    "boarding_pass_description_passenger_name" to "mDL धारक का अंतिम नाम, उपनाम या प्राथमिक पहचानकर्ता।",
    "boarding_pass_description_seat_number" to "सीट संख्या",
    "cor_attribute_administrative_number" to "प्रशासनिक संख्या",
    "cor_attribute_date_of_arrival" to "आगमन की तिथि",
    "cor_attribute_date_of_birth" to "जन्मतिथि",
    "cor_attribute_date_of_expiry" to "समाप्ति की तिथि",
    "cor_attribute_date_of_issue" to "जारी करने की तिथि",
    "cor_attribute_document_number" to "दस्तावेज़ संख्या",
    "cor_attribute_family_name" to "उपनाम",
    "cor_attribute_gender" to "लिंग",
    "cor_attribute_given_names" to "दिए गए नाम",
    "cor_attribute_issuing_authority" to "जारी करने वाला प्राधिकारी",
    "cor_attribute_issuing_country" to "जारी करने वाला देश",
    "cor_attribute_issuing_jurisdiction" to "जारी करने वाला क्षेत्राधिकार",
    "cor_attribute_nationality" to "राष्ट्रीयता",
    "cor_attribute_older_than_18" to "18 से ज़्यादा उम्र का",
    "cor_attribute_older_than_21" to "21 वर्ष से अधिक",
    "cor_attribute_place_of_birth" to "जन्म स्थान",
    "cor_attribute_resident_address" to "निवासी का पता",
    "cor_attribute_resident_city" to "निवासी शहर",
    "cor_attribute_resident_country" to "निवासी देश",
    "cor_attribute_resident_house_number" to "निवासी मकान नंबर",
    "cor_attribute_resident_postal_code" to "निवासी पिन कोड",
    "cor_attribute_resident_state" to "निवासी राज्य",
    "cor_attribute_resident_street" to "निवासी सड़क",
    "cor_description_administrative_number" to "COR प्रदाता द्वारा ऑडिट नियंत्रण या अन्य उद्देश्यों के लिए सौंपी गई एक संख्या।",
    "cor_description_date_of_arrival" to "वह दिन, महीना और वर्ष जब COR धारक EU पहुँचा।",
    "cor_description_date_of_birth" to "COR धारक के जन्म का दिन, महीना और वर्ष। यदि अज्ञात है, तो अनुमानित जन्मतिथि।",
    "cor_description_date_of_expiry" to "वह तिथि (और संभवतः समय) जब COR समाप्त हो जाएगा।",
    "cor_description_date_of_issue" to "वह तिथि (और संभवतः समय) जब COR जारी किया गया था।",
    "cor_description_document_number" to "COR के लिए एक संख्या, जो COR प्रदाता द्वारा सौंपी गई है।",
    "cor_description_family_name" to "COR धारक का वर्तमान अंतिम नाम(नामों), उपनाम(नामों) या प्राथमिक पहचानकर्ता",
    "cor_description_gender" to "COR धारक का लिंग।",
    "cor_description_given_names" to "COR धारक का वर्तमान पहला नाम(नामों), अन्य नाम(नामों) या द्वितीयक पहचानकर्ता",
    "cor_description_issuing_authority" to "प्रशासकीय प्राधिकारी का नाम जिसने यह COR इंस्टेंस जारी किया है, या संबंधित सदस्य राज्य का ISO 3166 अल्फा-2 देश कोड, यदि COR जारी करने के लिए कोई अलग प्राधिकारी अधिकृत नहीं है।",
    "cor_description_issuing_country" to "जारी करने वाले प्राधिकारी के देश या क्षेत्र का अल्फा-2 देश कोड, जैसा कि ISO 3166-1 में परिभाषित है।",
    "cor_description_issuing_jurisdiction" to "उस क्षेत्राधिकार का देश उपखंड कोड जिसने COR जारी किया है, जैसा कि ISO 3166-2:2020, खंड 8 में परिभाषित है। कोड का पहला भाग 'जारी करने वाले देश' (issuing_country) के मान के समान होना चाहिए।",
    "cor_description_nationality" to "ISO 3166-1 में निर्दिष्ट अल्फा-2 देश कोड, जो उपयोगकर्ता की राष्ट्रीयता का प्रतिनिधित्व करता है।",
    "cor_description_older_than_18" to "आयु 18 से अधिक?",
    "cor_description_older_than_21" to "आयु 21 से अधिक?",
    "cor_description_place_of_birth" to "वह स्थान जहाँ COR धारक का जन्म हुआ था।",
    "cor_description_resident_address" to "COR धारक के वर्तमान निवास का और/या संपर्क के लिए पूरा पता (सड़क/मकान नंबर, नगर पालिका आदि)।",
    "cor_description_resident_city" to "वह शहर जहाँ COR धारक वर्तमान में रहता है।",
    "cor_description_resident_country" to "वह देश जहाँ उपयोगकर्ता वर्तमान में रहता है, ISO 3166-1 में निर्दिष्ट अल्फा-2 देश कोड के रूप में।",
    "cor_description_resident_house_number" to "वह घर का नंबर जहाँ उपयोगकर्ता वर्तमान में रहता है, जिसमें कोई भी उपसर्ग या प्रत्यय शामिल है।",
    "cor_description_resident_postal_code" to "उस स्थान का पोस्टल कोड जहाँ COR धारक वर्तमान में रहता है।",
    "cor_description_resident_state" to "वह राज्य, प्रांत, ज़िला या स्थानीय क्षेत्र जहाँ उपयोगकर्ता वर्तमान में रहता है।",
    "cor_description_resident_street" to "उस सड़क का नाम जहाँ उपयोगकर्ता वर्तमान में रहता है।",
    "cor_request_age_over_18" to "18 वर्ष से अधिक आयु",
    "cor_request_all_data_elements" to "सभी डेटा तत्व",
    "cor_request_mandatory_data_elements" to "अनिवार्य डेटा तत्व",
    "document_display_name_boarding_pass" to "बोर्डिंग पास",
    "document_display_name_certificate_of_residency" to "निवास प्रमाण पत्र",
    "document_display_name_german_personal_id" to "जर्मन व्यक्तिगत आईडी",
    "document_display_name_loyalty_card" to "लॉयल्टी कार्ड",
    "document_display_name_movie_ticket" to "मूवी टिकट",
    "document_display_name_naturalization_certificate" to "देशीयकरण प्रमाण पत्र",
    "document_display_name_payment_card" to "भुगतान कार्ड",
    "german_id_attribute_administrative_number" to "प्रशासनिक संख्या",
    "german_id_attribute_age_in_years" to "वर्षों में आयु",
    "german_id_attribute_city_of_birth" to "जन्म शहर",
    "german_id_attribute_country_of_birth" to "जन्म देश",
    "german_id_attribute_date_of_birth" to "जन्म तिथि",
    "german_id_attribute_date_of_expiry" to "समाप्ति दिनांक",
    "german_id_attribute_date_of_issue" to "जारी दिनांक",
    "german_id_attribute_document_number" to "दस्तावेज़ संख्या",
    "german_id_attribute_family_name" to "अंतिम नाम",
    "german_id_attribute_family_name_at_birth" to "जन्म के समय उपनाम",
    "german_id_attribute_gender" to "लिंग",
    "german_id_attribute_given_names" to "दिए गए नाम",
    "german_id_attribute_issuing_authority" to "जारीकर्ता प्राधिकारी",
    "german_id_attribute_issuing_country" to "जारीकर्ता देश",
    "german_id_attribute_issuing_jurisdiction" to "जारीकर्ता क्षेत्राधिकार",
    "german_id_attribute_nationality" to "राष्ट्रीयता",
    "german_id_attribute_older_than_12" to "12 वर्ष से अधिक",
    "german_id_attribute_older_than_14" to "14 वर्ष से अधिक",
    "german_id_attribute_older_than_16" to "16 वर्ष से अधिक",
    "german_id_attribute_older_than_18" to "18 वर्ष से अधिक",
    "german_id_attribute_older_than_21" to "21 वर्ष से अधिक",
    "german_id_attribute_older_than_65" to "65 वर्ष से अधिक",
    "german_id_attribute_place_of_birth" to "जन्म स्थान",
    "german_id_attribute_resident_address" to "निवासी पता",
    "german_id_attribute_resident_city" to "निवासी शहर",
    "german_id_attribute_resident_country" to "निवासी देश",
    "german_id_attribute_resident_postal_code" to "निवासी डाक कोड",
    "german_id_attribute_state_of_birth" to "जन्म राज्य",
    "german_id_attribute_year_of_birth" to "जन्म का वर्ष",
    "german_id_description_administrative_number" to "PID प्रदाता द्वारा लेखापरीक्षा नियंत्रण या अन्य उद्देश्यों के लिए असाइन की गई एक संख्या।",
    "german_id_description_age_in_years" to "PID धारक की वर्षों में आयु",
    "german_id_description_city_of_birth" to "वह नगर पालिका, शहर, कस्बा या गाँव जहाँ PID उपयोगकर्ता का जन्म हुआ था।",
    "german_id_description_country_of_birth" to "पीआईडी उपयोगकर्ता के जन्म का देश, ISO 3166-1 में निर्दिष्ट अल्फा-2 देश कोड के अनुसार",
    "german_id_description_date_of_birth" to "वह दिन, महीना और वर्ष जब PID धारक का जन्म हुआ था। यदि अज्ञात है, तो जन्म की अनुमानित तिथि।",
    "german_id_description_date_of_expiry" to "वह तारीख (और संभवतः समय) जब PID की समय-सीमा समाप्त हो जाएगी।",
    "german_id_description_date_of_issue" to "वह तारीख (और संभवतः समय) जब PID जारी किया गया था।",
    "german_id_description_document_number" to "PID के लिए एक संख्या, जो PID प्रदाता द्वारा असाइन की गई है।",
    "german_id_description_family_name" to "PID धारक का वर्तमान अंतिम नाम (नाम), उपनाम (नाम), या प्राथमिक पहचानकर्ता",
    "german_id_description_family_name_at_birth" to "जन्म के समय पीआईडी धारक का अंतिम नाम (नाम), उपनाम (नाम), या प्राथमिक पहचानकर्ता",
    "german_id_description_gender" to "PID धारक का लिंग।",
    "german_id_description_given_names" to "PID धारक का वर्तमान पहला नाम (नाम), अन्य नाम (नाम), या द्वितीयक पहचानकर्ता",
    "german_id_description_issuing_authority" to "उस प्रशासनिक प्राधिकरण का नाम जिसने यह PID जारी किया है, या संबंधित सदस्य राज्य का ISO 3166 Alpha-2 देश कोड यदि PIDs जारी करने के लिए कोई अलग प्राधिकरण अधिकृत नहीं है।",
    "german_id_description_issuing_country" to "जारी करने वाले प्राधिकरण के देश या क्षेत्र का अल्फा-2 देश कोड, जैसा कि ISO 3166-1 में परिभाषित है।",
    "german_id_description_issuing_jurisdiction" to "उस अधिकार क्षेत्र का देश उपखंड कोड जिसने PID जारी किया है, जैसा कि ISO 3166-2:2020, खंड 8 में परिभाषित है। कोड का पहला भाग जारी करने वाले देश के मान के समान होना चाहिए।",
    "german_id_description_nationality" to "ISO 3166-1 में निर्दिष्ट Alpha-2 देश कोड की सूची, जो PID उपयोगकर्ता की राष्ट्रीयता दर्शाती है।",
    "german_id_description_older_than_12" to "आयु 12 वर्ष से अधिक?",
    "german_id_description_older_than_14" to "आयु 14 वर्ष से अधिक?",
    "german_id_description_older_than_16" to "आयु 16 वर्ष से अधिक?",
    "german_id_description_older_than_18" to "आयु 18 वर्ष से अधिक?",
    "german_id_description_older_than_21" to "आयु 21 वर्ष से अधिक?",
    "german_id_description_older_than_65" to "आयु 65 वर्ष से अधिक?",
    "german_id_description_place_of_birth" to "पीआईडी धारक के जन्म का देश और नगरपालिका या राज्य/प्रांत",
    "german_id_description_resident_address" to "उस स्थान का पूरा पता जहाँ PID धारक वर्तमान में रहता है और/या उससे संपर्क किया जा सकता है (गली/मकान नंबर, नगर पालिका आदि)।",
    "german_id_description_resident_city" to "वह शहर जहाँ PID धारक वर्तमान में रहता है।",
    "german_id_description_resident_country" to "वह देश जहाँ PID उपयोगकर्ता वर्तमान में रहता है, ISO 3166-1 में निर्दिष्ट Alpha-2 देश कोड के रूप में।",
    "german_id_description_resident_postal_code" to "उस स्थान का पिन कोड जहाँ PID धारक वर्तमान में रहता है।",
    "german_id_description_state_of_birth" to "पीआईडी उपयोगकर्ता के जन्म का राज्य, प्रांत, जिला या स्थानीय क्षेत्र",
    "german_id_description_year_of_birth" to "वह वर्ष जब PID धारक का जन्म हुआ था",
    "german_id_request_age_over_18" to "18 वर्ष से अधिक आयु",
    "german_id_request_all_data_elements" to "सभी डेटा तत्व",
    "german_id_request_mandatory_data_elements" to "अनिवार्य डेटा तत्व",
    "loyalty_attribute_date_of_expiry" to "समाप्ति तिथि",
    "loyalty_attribute_date_of_issue" to "जारी करने की तिथि",
    "loyalty_attribute_family_name" to "कुलनाम",
    "loyalty_attribute_given_names" to "प्रदत्त नाम",
    "loyalty_attribute_membership_id" to "सदस्यता आईडी",
    "loyalty_attribute_photo_of_holder" to "धारक का फ़ोटो",
    "loyalty_attribute_tier" to "टियर",
    "loyalty_description_date_of_expiry" to "समाप्ति की तारीख",
    "loyalty_description_date_of_issue" to "जारी होने की तारीख",
    "loyalty_description_family_name" to "दस्तावेज़ धारक का अंतिम नाम, उपनाम या प्राथमिक पहचानकर्ता",
    "loyalty_description_given_names" to "दस्तावेज़ धारक का पहला नाम, अन्य नाम या द्वितीयक पहचानकर्ता",
    "loyalty_description_membership_id" to "लॉयल्टी आईडी धारक का व्यक्ति पहचानकर्ता।",
    "loyalty_description_photo_of_holder" to "दस्तावेज़ धारक के चित्र की एक प्रति।",
    "loyalty_description_tier" to "सदस्यता टियर (बेसिक, सिल्वर, गोल्ड, प्लेटिनम, एलीट)",
    "loyalty_request_all_data_elements" to "सभी डेटा तत्व",
    "loyalty_request_mandatory_data_elements" to "अनिवार्य डेटा तत्व",
    "movie_ticket_attribute_age_rating_code" to "आयु रेटिंग कोड",
    "movie_ticket_attribute_cinema_theater" to "सिनेमाघर",
    "movie_ticket_attribute_date_and_time_of_show" to "शो की तारीख और समय",
    "movie_ticket_attribute_movie_poster" to "मूवी पोस्टर",
    "movie_ticket_attribute_movie_title" to "फ़िल्म का शीर्षक",
    "movie_ticket_attribute_parking" to "पार्किंग",
    "movie_ticket_attribute_seat" to "सीट",
    "movie_ticket_attribute_theater" to "थिएटर",
    "movie_ticket_attribute_ticket_number" to "टिकट नंबर",
    "movie_ticket_description_age_rating_code" to "आयु प्रतिबंधों के लिए फिल्म रेटिंग कोड",
    "movie_ticket_description_cinema_theater" to "सिनेमाघर का नाम, और/या प्रवेश का पता/स्थान।",
    "movie_ticket_description_date_and_time_of_show" to "फिल्म शुरू होने की तारीख और समय",
    "movie_ticket_description_movie_poster" to "फिल्म पोस्टर",
    "movie_ticket_description_movie_title" to "फिल्म का नाम, शीर्षक और शो की पहचान संबंधी अन्य कोई भी जानकारी।",
    "movie_ticket_description_parking" to "यदि कार पार्किंग टिकट खरीद के साथ प्रीपेड है",
    "movie_ticket_description_seat" to "सीट नंबर या कोड (जैसे पंक्ति/सीट)",
    "movie_ticket_description_theater" to "मल्टी-थिएटर सिनेमा इमारत में थिएटर का नाम या नंबर",
    "movie_ticket_description_ticket_number" to "खरीद के समय जारी की गई टिकट पहचान/संदर्भ संख्या।",
    "movie_ticket_request_all_data_elements" to "सभी डेटा तत्व",
    "movie_ticket_request_prepaid_parking" to "प्रीपेड पार्किंग",
    "movie_ticket_request_ticket_number" to "टिकट नंबर",
    "naturalization_attribute_date_of_birth" to "जन्म तिथि",
    "naturalization_attribute_date_of_naturalization" to "देशीयकरण की तिथि",
    "naturalization_attribute_family_name" to "उपनाम",
    "naturalization_attribute_given_names" to "दिए गए नाम",
    "naturalization_description_date_of_birth" to "वह दिन, माह और वर्ष जब देशीयकृत व्यक्ति का जन्म हुआ था। यदि अज्ञात है, तो अनुमानित जन्म तिथि।",
    "naturalization_description_date_of_naturalization" to "वह तिथि (और संभवतः समय) जब व्यक्ति का देशीयकरण किया गया था।",
    "naturalization_description_family_name" to "देशीयकृत व्यक्ति का वर्तमान उपनाम(नाम), कुलनाम(नाम) या प्राथमिक पहचानकर्ता",
    "naturalization_description_given_names" to "देशीयकृत व्यक्ति का वर्तमान प्रथम नाम(नाम), अन्य नाम(नाम) या द्वितीयक पहचानकर्ता",
    "naturalization_request_all_data_elements" to "सभी डेटा तत्व",
    "payment_attribute_expiry_date" to "समाप्ति तिथि",
    "payment_attribute_holder_name" to "धारक का नाम",
    "payment_attribute_issue_date" to "जारी करने की तिथि",
    "payment_attribute_issuer_name" to "जारीकर्ता का नाम",
    "payment_attribute_masked_account_reference" to "मास्क्ड खाता संदर्भ",
    "payment_attribute_payment_instrument_id" to "भुगतान साधन ID",
    "payment_description_expiry_date" to "इस क्रेडेंशियल के समाप्त होने की तिथि।",
    "payment_description_holder_name" to "भुगतान खाता धारक का नाम।",
    "payment_description_issue_date" to "इस क्रेडेंशियल को जारी करने की तिथि।",
    "payment_description_issuer_name" to "जारीकर्ता का नाम।",
    "payment_description_masked_account_reference" to "मास्क्ड खाता संदर्भ, उदाहरण के लिए पैन के अंतिम 4 अंक।",
    "payment_description_payment_instrument_id" to "टोकनाइज़ किया गया भुगतान साधन पहचानकर्ता।",
    "payment_request_payment_sca_all" to "भुगतान SCA (सभी डेटा तत्व)",
    "payment_request_payment_sca_minimal" to "भुगतान SCA (न्यूनतम)",
    "payment_request_payment_sca_transaction" to "भुगतान लेन-देन के साथ भुगतान SCA"
)
